import { Button, Dialog } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { Messaggio } from "../prismaTypes";
import { uiStore } from "../uiStore";
import { MessaggiAdminTable } from "./MessaggiAdminTable";
import { MessaggioUi } from "./MessaggioUi";

export function MessaggiAdmin() {
  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => setTitle("Comunicazioni"), [setTitle]);

  const [open, setOpen] = useState(false);
  const [mess, setMess] = useState<Messaggio | undefined>(undefined);
  const onNewClick = useCallback(() => {
    setMess(undefined);
    setOpen(true);
  }, [setMess, setOpen]);

  const onEdit = useCallback(
    (mess1: Messaggio) => {
      setMess(mess1);
      setOpen(true);
    },
    [setMess, setOpen]
  );

  return (
    <>
      <Button onClick={onNewClick} variant="contained" color="success" sx={{ mb: 1 }}>
        Nuova Comunicazione
      </Button>
      <MessaggiAdminTable onEdit={onEdit} />

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true}>
        <MessaggioUi messaggio={mess} handleClose={() => setOpen(false)} />
      </Dialog>
    </>
  );
}
